module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.39873/js/img/valuePropsSection/tailoredOnboarding.jpg"